import { makeEntityScaffold } from '@classpass/saga-tools';

import URLS from 'constants/urls';

const handler = ({ httpClient }, newLocale) => httpClient.post(URLS.user.updateLocale, { locale: newLocale });

export default makeEntityScaffold('SAGA.API.UPDATE_LOCALE', handler);
